// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_tb-5";
export var filledCircle = "_tb-4";
export var historyEntry = "_tb-3";
export var messageSideLeft = "_tb-1";
export var messageSideRight = "_tb-2";
export var orderTrackingCarouselWrapper = "_tb-6";
export var orderTrackingInfoContainer = "_tb-0";